import React, { useState, useRef, useEffect } from "react";
import { process } from "@progress/kendo-data-query";
import { useDispatch, useSelector } from "react-redux";
import { getActiveCurrency } from "actions/currency.action";
import "@progress/kendo-react-intl";
import "@progress/kendo-react-dropdowns";
import "react-router-dom";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { Checkbox } from "@progress/kendo-react-inputs";
import AddNominal from "./AddNewNominal.jsx";
import { AmountFormatCell } from "components/common/formatter";
import { NominalTypeFormatCell } from "components/common/nominalTypeFormatter";
import { ColumnsButton } from "components/common/ColumnsButton";
import {
    changeNominalToLedgerRef,
    getactiveNominals,
    getViewNominals,
    getNominalsList,
} from "actions/nominals.action.js";
import SearchTextBox from "components/SearchComponent.jsx";
import { arrowRotateCwIcon as refreshIcon } from "@progress/kendo-svg-icons";
import styles from "./nominal.module.scss";
import { useNavigate } from "react-router-dom";
import { RedirectCell } from "components/common/GridComponents.jsx";
import { GridLoader } from "components/GridLoader.jsx";

const columnsData = [
    {
        title: "Nominal Ref",
        field: "NominalRef",
        show: true,
    },
    {
        title: "Nominal Name",
        field: "NominalName",
        show: true,
    },
    {
        title: "Type",
        field: "Type",
        show: true,
    },
    {
        title: "Group",
        field: "Group",
        show: true,
    },
    {
        title: "VAT Code",
        field: "VATCode",
        show: true,
    },
    {
        title: "Currency",
        field: "Currency",
        show: true,
    },
    {
        title: "Balance",
        field: "Balance",
        show: true,
    },
];

const initialSort = [
    {
        field: "nominalRef",
        dir: "asc",
    },
];

const Nominal = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showState, setShowState] = useState();
    const [searchValue, setSearchValue] = useState("");
    const searchRef = useRef();

    const [dataState, setDataState] = useState({
        take: 50,
        skip: 0,
        sort: [
            {
                field: "nominalRef",
                dir: "asc",
            },
        ],
    });

    const { nominalList, isNominalUpdated } = useSelector(
        (state) => state.nominalList
    );
    const [dataResult, setDataResult] = useState(process([], dataState));
    const [archiveChecked, setArchiveChecked] = useState(true);
    const [includeZeroChecked, setIncludeZeroChecked] = useState(true);
    const [columns, setColumns] = useState(columnsData);
    const [isLoading, setIsLoading] = useState(true);

    const getNominalsData = () => {
        setIsLoading(true);
        let parameter = "";
        if (archiveChecked) {
            parameter += "&excludeArchived=true";
        }
        if (includeZeroChecked) {
            parameter += "&excludeZeroBalance=true";
        }
        if (searchValue) {
            parameter += `&search=${searchValue}`;
        }
        dispatch(getNominalsList(parameter));
    };

    useEffect(() => {
        getNominalsData();
    }, [archiveChecked, includeZeroChecked, searchValue]);

    useEffect(() => {
        if (isNominalUpdated) {
            getNominalsData();
        }
    }, [isNominalUpdated]);

    useEffect(() => {
        if (nominalList?.data) {
            setDataResult(process(nominalList.data, dataState));
            setIsLoading(false);
        }
    }, [nominalList, dataState]);

    useEffect(() => {
        dispatch(getactiveNominals());
        dispatch(getActiveCurrency());
    }, [dispatch]);

    const handleAction = (nominalId) => {
        dispatch(getViewNominals(nominalId));
        setShowState("View");
    };

    const onSubmit = (columns) => {
        setColumns(columns);
    };

    const LedgerCell = (props) => {
        return (
            <td>
                <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        dispatch(changeNominalToLedgerRef(props.dataItem.nominalRef));
                        navigate(`/nominal/nominalledger`);
                    }}
                >
                    <u>{props.dataItem.nominalRef}</u>
                </span>
            </td>
        );
    };

    const showColumn = (field) => {
        return columns.some((col) => col.field == field && col.show == true);
    };

    const handleRefresh = () => {
        setIsLoading(true);
        setSearchValue("");
        searchRef.current.clearSearch();
        setDataState({
            ...dataState,
            skip: 0,
        });
        getNominalsData();
    };

    const Redirect = (props) => (
        <RedirectCell handleClick={() => handleAction(props.dataItem.nominalId)} />
    );

    return (
        <>
            <div className="page h-100 d-flex flex-column">

                <div className="grid-layout-container" style={{ marginBottom: 20 }}>
                    <div className="title menu-button flex justify-space-between align-items-start align-items-xl-center">
                        <div className="d-flex flex-column flex-xl-row gap-3 gap-xl-0">
                            <div className="d-flex">
                                <SearchTextBox
                                    ref={searchRef}
                                    changeFilterValue={setSearchValue}
                                />
                                <Button
                                    className="ms-1 ms-xxl-3 border-0 common-btn"
                                    svgIcon={refreshIcon}
                                    onClick={handleRefresh}
                                >
                                    Refresh
                                </Button>
                            </div>
                            <div
                                className={`ms-0 ms-xl-3 ms-xxl-4 ${styles["checkbox-label"]}`}
                                style={{
                                    flexDirection: "column",
                                    display: "flex",
                                    fontSize: 15,
                                    fontWeight: "500",
                                }}
                            >
                                <Checkbox
                                    defaultChecked={true}
                                    checked={includeZeroChecked}
                                    onClick={() => setIncludeZeroChecked(!includeZeroChecked)}
                                    label={"Exclude Zero Balances"}
                                />
                                <Checkbox
                                    defaultChecked={true}
                                    checked={archiveChecked}
                                    onClick={() => setArchiveChecked(!archiveChecked)}
                                    label={"Exclude Archived"}
                                />
                            </div>
                        </div>

                        <div className="d-flex flex-column-reverse flex-xl-row gap-2 gap-xl-1 gap-xxl-3">
                            <ColumnsButton
                                className=""
                                columnsData={columnsData}
                                onSubmit={onSubmit}

                            />


                            <Button
                                className="common-btn"
                                style={{
                                    width: "129px",
                                }}
                                onClick={() => setShowState("Add")}
                            >
                                Add Nominal
                            </Button>
                        </div>
                    </div>
                </div>

                <Grid
                    data={dataResult}
                    className="mb-1 fs-md flex-grow-1 overflow-auto grid-minwidth-col2-200 "
                    sortable={true}
                    defaultSort={initialSort}
                    onDataStateChange={(e) => {
                        setDataState(e.dataState);
                        setDataResult(process(nominalList?.data || [], e.dataState));
                    }}
                    {...dataState}
                    pageable={{
                        pageSizes: [10, 20, 50, 100],
                    }}
                    resizable={true}
                    showLoader={isLoading}
                    loader={<GridLoader />}
                >
                    <GridNoRecords>
                        {isLoading ? (
                            <div style={{ height: "110px" }}></div>
                        ) : (
                            dataResult.data && dataResult.data.length === 0 && "No records available"
                        )}
                    </GridNoRecords>
                    {showColumn("NominalRef") && (
                        <GridColumn
                            field="nominalRef"
                            title="Nominal Ref"
                            width="140px"
                            cell={LedgerCell}
                        />
                    )}

                    {showColumn("NominalName") && (
                        <GridColumn
                            field="nominalName"
                            title="Nominal Name"
                            className="gridBoldField"
                        />
                    )}

                    <GridColumn field="branchName" title="Branch" width="100px" />

                    {showColumn("Type") && (
                        <GridColumn
                            field="typeName"
                            title="Type"
                            cell={NominalTypeFormatCell}
                            width="140px"
                        />
                    )}
                    {showColumn("Group") && (
                        <GridColumn
                            field="subTypeName"
                            title="Sub Type"
                            cell={NominalTypeFormatCell}
                            width="140px"
                        />
                    )}
                    {showColumn("VATCode") && (
                        <GridColumn field="vatDetails" title="VAT Code" width="180px" />
                    )}
                    {showColumn("Currency") && (
                        <GridColumn field="currencyCode" title="Cur" width="60px" />
                    )}
                    {showColumn("Balance") && (
                        <GridColumn
                            field="balance"
                            title="Balance"
                            width="120px"
                            className="balanceCol balanceTd"
                            cell={AmountFormatCell}
                            headerClassName="grid-header-center"
                        />
                    )}
                    {archiveChecked && (
                        <GridColumn field="archived" title="Archived" className="text-center" width="90px" />
                    )}
                    <GridColumn width="60px" cell={Redirect} sortable={false} />
                </Grid>
            </div>

            {showState && (
                <AddNominal
                    view={showState}
                    onClose={() => {
                        setShowState(undefined);
                    }}
                />
            )}
        </>
    );
};
export default Nominal;
